export const AI_ASSISTANT_SEARCH_ENGINES = {
  openaiResponses: "openai-responses",
  openai: "openai",
  velvet: "velvet",
  openrouter: "openrouter",
  openrouterStreaming: "openrouter-streaming",
  openrouterNoThink: "openrouter-no-think"
};

export const isOpenAI = type =>
  type === AI_ASSISTANT_SEARCH_ENGINES.openai || type === AI_ASSISTANT_SEARCH_ENGINES.openaiResponses;

export const isVelvet = type => type === AI_ASSISTANT_SEARCH_ENGINES.velvet;

export const isOpenRouter = type =>
  type === AI_ASSISTANT_SEARCH_ENGINES.openrouter ||
  type === AI_ASSISTANT_SEARCH_ENGINES.openrouterStreaming ||
  type === AI_ASSISTANT_SEARCH_ENGINES.openrouterNoThink;

export const AI_ASSISTANT_SEARCH_ENGINE_LIST = [
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.openaiResponses,
    label: "OpenAI Responses"
  },
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.openai,
    label: "OpenAI Assistants (deprecated)"
  },
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.velvet,
    label: "Velvet"
  },
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.openrouter,
    label: "OpenRouter"
  },
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.openrouterStreaming,
    label: "OpenRouter Streaming"
  },
  {
    id: AI_ASSISTANT_SEARCH_ENGINES.openrouterNoThink,
    label: "OpenRouter No-Think"
  }
];
